export const SET_PROFILE_DATA = "SET_PROFILE_DATA";
export const SET_PROFILE_PHOTO = "SET_PROFILE_PHOTO";
export const SET_FAVORITE_LISTINGS = "SET_FAVORITE_LISTINGS";
export const SET_FAVORITE_LISTING = "SET_FAVORITE_LISTING";
